var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 59,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 4.33268H15.5833V0.666016H2.74996C1.74163 0.666016 0.916626 1.49102 0.916626 2.49935V12.5827H2.74996C2.74996 14.1043 3.97829 15.3327 5.49996 15.3327C7.02163 15.3327 8.24996 14.1043 8.24996 12.5827H13.75C13.75 14.1043 14.9783 15.3327 16.5 15.3327C18.0216 15.3327 19.25 14.1043 19.25 12.5827H21.0833V7.99935L18.3333 4.33268ZM5.49996 13.9577C4.73913 13.9577 4.12496 13.3435 4.12496 12.5827C4.12496 11.8218 4.73913 11.2077 5.49996 11.2077C6.26079 11.2077 6.87496 11.8218 6.87496 12.5827C6.87496 13.3435 6.26079 13.9577 5.49996 13.9577ZM17.875 5.70768L19.6716 7.99935H15.5833V5.70768H17.875ZM16.5 13.9577C15.7391 13.9577 15.125 13.3435 15.125 12.5827C15.125 11.8218 15.7391 11.2077 16.5 11.2077C17.2608 11.2077 17.875 11.8218 17.875 12.5827C17.875 13.3435 17.2608 13.9577 16.5 13.9577Z",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.4fbbd5bf.svg";
export { ForwardRef as ReactComponent };